var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Path 178"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"Pledge---Layout","transform":"translate(-710.000000, -1264.000000)","stroke":"#FFFFFF","strokeWidth":"2"},React.createElement("g",{"id":"Group-2","transform":"translate(640.000000, 1180.000000)"},React.createElement("g",{"id":"Checkbox","transform":"translate(65.000000, 70.000000)"},React.createElement("polyline",{"id":"Path-178","points":"6 17.6487677 8.15061605 19.7993838 12.9499998 15"})))))]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"width":"9px","height":"8px","viewBox":"0 0 9 8","version":"1.1"};

module.exports = Icon;

Icon.default = Icon;



//////////////////
// WEBPACK FOOTER
// ../node_modules/svg-react-loader/lib/loader.js?name=Icon!./client/assets/icons/check-white.svg
// module id = 370
// module chunks = 0